export default __webpack_public_path__ + "static/media/pet-bed.f3eb39f2.png";